(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["campaign-media-core"] && !Shopify.designMode) return;
  try {
    (function initCampaignVideoAutoplay() {
    function handleIntersection(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.play().catch(() => {});
        } else {
          entry.target.pause();
        }
      }
    }

    const observer = new IntersectionObserver(handleIntersection, { threshold: 0.25 });

    function observeVideos() {
      for (const $video of document.querySelectorAll('.campaign-media-core__video')) {
        if ($video.dataset.scrollObserved) continue;
        $video.dataset.scrollObserved = 'true';
        observer.observe($video);
      }
    }

    observeVideos();
    document.addEventListener('shopify:section:load', observeVideos);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker--c-image-carousel"] && !Shopify.designMode) return;
  try {
    (function colourPickerCarouselInit() {
    const $carousels = document.querySelectorAll('.product__info__colour-picker--c');
    if (!$carousels.length) return;

    $carousels.forEach(function initCarousel($carousel) {
      const $items = $carousel.querySelectorAll('.product__info__colour-picker--c__label');
      if ($items.length <= 2) return;

      const $selectedItem = $carousel.querySelector('[data-selected]');
      if (!$selectedItem) return;

      function scrollToSelected() {
        const carouselRect = $carousel.getBoundingClientRect();
        const itemRect = $selectedItem.getBoundingClientRect();
        const scrollLeft = $selectedItem.offsetLeft - (carouselRect.width / 2) + (itemRect.width / 2);
        $carousel.scrollTo({
          left: Math.max(0, scrollLeft),
          behavior: 'smooth'
        });
      }

      let savedScrollLeft = null;
      $carousel.addEventListener('mousedown', function saveScrollPosition() {
        savedScrollLeft = $carousel.scrollLeft;
      });

      $carousel.addEventListener('focusin', function restoreScrollPosition() {
        if (savedScrollLeft !== null) {
          $carousel.scrollLeft = savedScrollLeft;
          savedScrollLeft = null;
        }
      });

      if (document.readyState === 'complete') {
        scrollToSelected();
      } else {
        window.addEventListener('load', scrollToSelected);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
